import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { styled } from "@mui/material/styles";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Icon, VisuallyHidden } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
var MemberItem = styled("li")({
    "display": "flex",
    "alignItems": "flex-start",
    "gap": "7px",
    "listStyle": "none",
    "margin": "0 -6px",
    "padding": "3px 6px",
    "borderRadius": "4px",
    "lineHeight": 1.5,
    "minWidth": 0,
    "overflowWrap": "anywhere",
    "& .slate-member-check": {
        flex: "none",
        width: "16px",
        height: "21px",
        fontSize: "13px",
        visibility: "hidden",
        color: "#047857",
    },
    "& .slate-member-name": {
        minWidth: 0,
        fontSize: "14px",
    },
    "&.slate-member-selected": {
        backgroundColor: "#eaf7f1",
        color: "#065f46",
    },
    "&.slate-member-selected .slate-member-check": {
        visibility: "visible",
    },
    "&.slate-member-selected .slate-member-name": {
        fontWeight: 600,
    },
});
export var SlateMember = function (_a) {
    var selected = _a.selected, candidateId = _a.candidateId, className = _a.className, children = _a.children;
    var t = useTranslation().t;
    return (_jsxs(MemberItem, { className: ["slate-member", selected ? "slate-member-selected" : "", className !== null && className !== void 0 ? className : ""]
            .filter(Boolean)
            .join(" "), "data-candidate-id": candidateId, children: [_jsx(Icon, { className: "slate-member-check", icon: faCheck, "aria-hidden": "true" }), _jsx("span", { className: "slate-member-name", children: children }), selected && (_jsx(VisuallyHidden, { className: "slate-member-selected-label", component: "span", children: t("slates.selection.selected") }))] }));
};
